/* eslint-disable max-len */
import React, { Fragment, useContext } from 'react';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import ViewDocument from './ViewDocument';
import PrintDocument from './PrintDocument';

function Requirements({ data }) {
  const permissions = getJson('permissions');
  const setModal = useContext(ModalContext);
  const tabList = () => {
    const filteredData = data?.filter(
      (x) => x.attributes.requirement_name !== null
    );
    if (Acl(permissions, ['EBPLS BPLO DEPARTMENT - REQUIREMENT'])) {
      return filteredData;
    }
    if (Acl(permissions, ['EBPLS PLANNING DEPARTMENT - REQUIREMENT'])) {
      return filteredData?.filter((x) => x.attributes.for_planning === 1);
    }
    if (Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - REQUIREMENT'])) {
      return filteredData?.filter((x) => x.attributes.for_engineering === 1);
    }
    return filteredData;
  };

  const handleViewRequirement = (item) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewDocument data={item} />,
      title: `View Required Document`,
      modalSize: 'modal-xl',
    });
  };

  const handlePrintRequirement = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintDocument data={item} />,
      title: `Print Required Document`,
      modalSize: 'modal-xl',
    });
  };

  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          <tr>
            <td className="cms-text-primary bg-white" colSpan={2}>
              <b>List of Required Documents</b>
            </td>
          </tr>
          <tr>
            <th
              className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
              width="80%"
            >
              Document Name
            </th>
            <th
              className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
              width="20%"
            >
              Actions
            </th>
          </tr>
          {!_.isEmpty(tabList()) ? (
            tabList().map((item) => {
              return (
                <Fragment key={item.id}>
                  <tr>
                    <td className="text-dark">
                      {_.get(item, 'attributes.requirement_name') || '-'}
                    </td>
                    <td>
                      {/* <button
                      type="button"
                      onClick={handleDownloadRequirement(_.get(item, 'attributes.data[0].url'), _.get(item, 'attributes.data[0].file_type'))}
                      className="btn-blank"
                    >
                      <i className="fas fa-print icon-print cms-bg-color-primary" />
                    </button> */}
                      <button
                        type="button"
                        onClick={handlePrintRequirement(
                          _.get(item, 'attributes.data')
                        )}
                        className="btn-blank"
                      >
                        <i className="fas fa-print icon-print cms-bg-color-primary" />
                      </button>
                      <button
                        type="button"
                        onClick={handleViewRequirement(
                          _.get(item, 'attributes.data')
                        )}
                        className="btn-blank"
                      >
                        <i className="far fa-eye icon-view-only" />
                      </button>
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr className="text-dark text-center">
              <td className="text-dark text-center" colSpan="2">
                No Requirements
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

Requirements.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(Requirements);
